export default Backbone.View.extend({
  events: {
    'click .js-readmore': 'destroyDotdotdot',
  },

  initialize(options) {
    this.quickView = options.quickView;
    this.quickView.$el.on('shown.bs.modal', _.bind(this.initializeDotdotdot, this));

    this.initializeDotdotdot();
  },

  initializeDotdotdot() {
    // Initialize the description collapsing
    this.$el.dotdotdot({
      height: 80,
      after: '.js-readmore',
      callback: _.bind(this.dotdotdotCallback, this),
    });
  },

  dotdotdotCallback(isTruncated, originalContent) {
    if (!isTruncated) {
      this.$('.js-readmore').hide();
    }
  },

  destroyDotdotdot() {
    this.$el.dotdotdot('destroy');
    this.$('.js-readmore').hide();
  },

  destroyView() {
    this.undelegateEvents();
    this.remove();
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/sitter_card_quick_view_description_view.js